import { LoadingMask } from "@/components/common/LoadingMask/LoadingMask";
import lookupApiEndpoint, { checkApiResponse, checkInpasu } from "@/services/lookup/lookupApiEndpoint";
import useEndpointStore from "@/stores/useEndpointStore";
import useToastStore from "@/stores/useToastStore";
import urlJoin from "url-join";
import type { FetchLike, WretchOptions } from "wretch";

const endpointMiddleware = (next: FetchLike) => async (url: string, opts: WretchOptions) => {
  try {
    let resolveUrl = url;
    const { origin, pathname, search } = new URL(url);
    const apiEndpoint = useEndpointStore.getState().apiEndpoint;

    if (apiEndpoint && apiEndpoint !== origin) {
      resolveUrl = urlJoin(apiEndpoint, pathname, search);
    }

    const res = await next(resolveUrl, opts);

    const inpasu = res.headers.get("X-Inpasu");
    const clone = res.clone();
    const json = await clone.json();
    const correctHeader = checkInpasu(inpasu);
    const correctResponse = checkApiResponse(json);

    if (correctResponse && correctHeader) {
      return res;
    }

    const error = new TypeError("Invalid response");
    error.name = "InvalidResponseError";
    throw error;
  } catch (e: unknown) {
    if (!(e instanceof TypeError) || !["InvalidResponseError", "TypeError"].includes(e.name)) {
      throw e;
    }
    const cancelId = setTimeout(() => {
      LoadingMask.open();
    }, 500);
    const fastEndpoint = await lookupApiEndpoint.start();

    LoadingMask.close();
    clearTimeout(cancelId);

    const { pathname, search } = new URL(url);
    const newUrl = urlJoin(fastEndpoint, pathname, search);

    useToastStore.getState().show({
      type: "info",
      message: 't("NORMAL.CHANGE_CONNECTION")',
    });

    return next(newUrl, opts);
  }
};

export default endpointMiddleware;
